import { ref, computed } from "vue";
import { defineStore } from "pinia";
import type {SiteNotification} from "@/types/site_admin/siteNotifications";
import {useAuthStore} from "@/stores/auth";

export const useNavbarStore = defineStore("navbar", () => {
    const pageTitle = '';
    const siteNotificationsList = ref<SiteNotification[]>([]);
    const notificationsListOpen = ref(false);
    const notificationPopupOpen = ref(false);
    const notificationPopupTitle = ref('');
    const notificationPopupMessage = ref('');
    const popupNotificationId = ref(0);
    const isTestPopupNotification = ref(false);
    const authStore = useAuthStore();

    const closeNotificationPopup = () => {
        notificationPopupOpen.value = false;
        notificationPopupTitle.value = '';
        notificationPopupMessage.value = '';
        openPopupNextPopupNotification();
    }

    const openNotificationPopup = (title:string, message:string, id:number, isTest = false) => {
        notificationPopupOpen.value = true;
        notificationPopupTitle.value = title;
        notificationPopupMessage.value = message;
        popupNotificationId.value = id;
        isTestPopupNotification.value = isTest;
    }

    const closeNotificationsList = () => {
        notificationsListOpen.value = false;
        isTestPopupNotification.value = false;
    }

    const openNotificationsList = () => {
        notificationsListOpen.value = true;
    }

    const toggleNotificationsList = () => {
        notificationsListOpen.value = !notificationsListOpen.value;
    }

    const filteredSiteNotifications = computed(() => {
        const filtered_notifications:SiteNotification[] = [];

        const current_timestamp = Date.now();

        siteNotificationsList.value.forEach(sn => {
            if(sn.admin_from?.getTime() <= current_timestamp)
            {
                filtered_notifications.push(sn);
            }
        })

        return filtered_notifications;
    });

    const activeNotifications = computed(() => {

        const current_time = Date.now();
        let active_notification = 0;

        filteredSiteNotifications.value.forEach(sn => {
            if(sn.admin_enabled === true &&
                sn.admin_from <= current_time &&
                sn.admin_until >= current_time &&
                !sn.notificationInteractions.find(el => el.user_id === authStore.user.id)
            )
            {
                active_notification++;
            }
        })

        return active_notification;
    });

    const openPopupNextPopupNotification = () => {
        const auth = useAuthStore();

        const current_time = Date.now();


        filteredSiteNotifications.value.forEach(sn => {
            if(
                sn.admin_force_show === 1 &&
                sn.admin_enabled === true &&
                sn.admin_from <= current_time &&
                sn.admin_until >= current_time &&
                !auth.hiddenAdminSiteNotificationIds.includes(sn.id)
            )
            {
                openNotificationPopup(sn.admin_name, sn.admin_message, sn.id);
            }
        })
    }

    return {
        pageTitle,
        siteNotificationsList,
        activeNotifications,
        notificationsListOpen,
        notificationPopupOpen,
        notificationPopupTitle,
        notificationPopupMessage,
        closeNotificationPopup,
        openNotificationPopup,
        closeNotificationsList,
        openNotificationsList,
        toggleNotificationsList,
        popupNotificationId,
        isTestPopupNotification,
        filteredSiteNotifications,
        openPopupNextPopupNotification,
    };
});
